import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError, tap } from 'rxjs/operators';
export const HOST="134.209.199.123"
// export const HOST="localhost"

export const API_URL="http://"+HOST+":8888/"
export const SOCKET_URL="wss://booking.healthixsolutions.com/api/"

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(private http: HttpClient) { }

  postSignature(data): Observable<any> {
    return this.http.post(API_URL + 'signature/',data).pipe(
      map((res)=>{return res;}));
  }
}
